import { render, staticRenderFns } from "./ui-feedback.vue?vue&type=template&id=7d2f5910&scoped=true&"
import script from "./ui-feedback.vue?vue&type=script&lang=js&"
export * from "./ui-feedback.vue?vue&type=script&lang=js&"
import style0 from "./ui-feedback.vue?vue&type=style&index=0&id=7d2f5910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f5910",
  null
  
)

export default component.exports